<template>
  <div>
    <b-container fluid>
      <b-button class="mb-3" @click="$router.go(-1)" variant="outline-dark">
        <b-icon-arrow-bar-left size="lg"></b-icon-arrow-bar-left>
        Back
      </b-button>
      <b-row>
        <b-col class="p-0 m-0">
          <b-row>
            <b-col>
              <b-skeleton-wrapper class="text-center" :loading="loading2">
                <template #loading>
                  <b-skeleton height="100px" width="100%"></b-skeleton>
                </template>
              </b-skeleton-wrapper>
              <div v-if="!loading2" class="board-wrapper">
                <digit-board
                  class="board-items"
                  title="Total No of Testgroups"
                  symbol=""
                  :value="analyticsData?.totalTestgroups"
                  color="green"
                ></digit-board>
                <digit-board
                  class="board-items"
                  title="No of Available Testgroups"
                  symbol=""
                  :value="analyticsData?.totalAvailableTestgroups"
                  color="green"
                ></digit-board>
                <digit-board
                  class="board-items"
                  title="No of Unavailable Testgroups"
                  symbol=""
                  :value="analyticsData?.totalUnavailableTestgroups"
                  color="green"
                ></digit-board>
              </div>
            </b-col>
          </b-row>

          <b-skeleton-wrapper class="text-center mt-3" :loading="loading">
            <template #loading>
              <b-skeleton width="100%"></b-skeleton>
              <b-skeleton width="80%"></b-skeleton>
              <b-skeleton width="90%"></b-skeleton>
              <b-skeleton width="100%" class="mt-3"></b-skeleton>
              <b-skeleton width="80%"></b-skeleton>
              <b-skeleton width="90%"></b-skeleton>
              <b-skeleton width="100%" class="mt-3"></b-skeleton>
              <b-skeleton width="80%"></b-skeleton>
              <b-skeleton width="100%"></b-skeleton>
              <b-skeleton width="100%" class="mt-3"></b-skeleton>
              <b-skeleton width="80%"></b-skeleton>
              <b-skeleton width="100%"></b-skeleton>
              <b-skeleton width="100%" class="mt-3"></b-skeleton>
              <b-skeleton width="80%"></b-skeleton>
              <b-skeleton width="90%"></b-skeleton>
              <b-skeleton width="100%" class="mt-3"></b-skeleton>
              <b-skeleton width="80%"></b-skeleton>
              <b-skeleton width="100%"></b-skeleton>
            </template>
          </b-skeleton-wrapper>

          <div class="nested-form-group">
            <div class="flex-head mb-3">
              <b-button
                class="prompt-button p-2"
                :to="{ name: 'addtestgroup' }"
                variant="success"
                >Create New</b-button
              >
            </div>
            <div style="width: 400px">
              <b-input-group class="mb-2">
                <b-input-group-prepend is-text>
                  <b-icon icon="search"></b-icon>
                </b-input-group-prepend>
                <b-form-input
                  type="search"
                  v-model="searchQuery"
                  @keyup="searchFilter"
                  @update="clearFilter"
                  @focus="searching = true"
                  placeholder="Search"
                ></b-form-input>
              </b-input-group>
            </div>
          </div>

          <b-table
            v-if="institutionsarr?.length > 0 && !loading"
            striped
            hover
            responsive
            head-variant="dark"
            class="tablerr"
            :items="usedatas"
            :fields="headers"
          >
            <template #cell(sn)="data">
              {{ data.index + 1 + (pages - 1) * intervalnum }}
            </template>
            <template #cell(test_code)="data">
              <span>{{ data.item.trx_code }}</span>
            </template>
            <template #cell(no_of_candidates)="data">
              <span>{{ JSON.parse(data.item.test_takers).length }}</span>
            </template>
            <template #cell(test_status)="data">
              <span>
                <b-badge
                  :disabled="true"
                  :variant="
                    data.item.test_status == 'Closed' ? 'danger' : 'success'
                  "
                  >{{ data.item.test_status }}</b-badge
                >
              </span>
            </template>
            <template #cell(action)="data">
              <div>
                <b-icon-three-dots-vertical
                  :id="`popover-1-table-ts${data.index}`"
                  variant="primary"
                ></b-icon-three-dots-vertical>
                <b-popover
                  :target="`popover-1-table-ts${data.index}`"
                  placement="bottomright"
                  title=""
                  triggers="hover focus"
                >
                  <div style="width: 170px; min-height: 40px" class="">
                    <div
                      @click="
                        $router.push({ name: details.category == 'Organization' ? 'viewtestgrouporg' : 'viewtestgroup', params: { trackid: data.item.track_id,  insti : data.item.short_name } })
                      "
                      class="cursor-pointer action-link p-1 px-2"
                    >
                      <p class="text-sm">View Candidates</p>
                    </div>
                    <div
                      @click="
                        $router.push({ name: details.category == 'Organization' ? 'addtestgroup' : 'addinstitution', params: { trackid: data.item.track_id,  insti : data.item.short_name }, query : { domain : details.category == 'Organization' ? 'thirdparty' : 'base' } })
                      "
                      class="cursor-pointer action-link p-1 px-2"
                    >
                      <p class="text-sm">Edit</p>
                    </div>
                    <div @click="confirmDelete(), currentId = data.item.track_id" class="cursor-pointer action-link p-1 px-2">
                      <p class="text-sm">Delete</p>
                    </div>
                  </div>
                </b-popover>
              </div>
            </template>
          </b-table>

          <div class="text-center mt-5" v-if="institutionsarr?.length <= 0">
            No Data to show
          </div>

          <b-modal
            id="modal-delete-space"
            centered
            title="Confirm remove"
            ok
            ok-variant="success"
            cancel-variant="danger"
            @ok="deleteTestgroup()"
          >
            <template v-slot:modal-ok> Delete Testgroup</template>
            <p>
              Are you sure you want to delete this Testgroup? Testspaces using this Testgroup will experience issues serving tests.
            </p>
          </b-modal>
        
          <paginater
            :intervalnum="intervalnum"
            :pages="pages"
            :endnum="endnum"
            :endss="endss"
            :datalength="endss"
            @paginator="newPage"
            @changeInterval="effectInterval"
          ></paginater>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
// import institutionsPagelist from "@/components/admin/institutionsPagelist";
import Paginater from "@/components/Paginater"
import { mapState, mapActions } from "vuex";
import store from "@/store";
import digitBoard from "@/components/digitBoard";

export default {
  components: {
    // InstitutionsList,
    // institutionsPagelist,
    digitBoard,
    Paginater,
  },

  data() {
    return {
        startnum: 0,
        limitnum: this.endss,
        intervalnum: 10,
        endnum: 10,
        btnrange : this.endss,
        pages : 1,
        loc : "addtestgroup",
        searchQuery: "",
        searching: false,
        loading: false,
        loading2: false,
        analyticsData: {},
        currentId: ""
    };
  },
  beforeRouteEnter(to, from, next) {
    store.dispatch("admin/fetchAllInstitutions");
    store.dispatch("admin/fetchCategories");
    store.dispatch("admin/fetchInstitutionsTable");
    next();
  },
  beforeRouteLeave(to, from, next) {
    this.setinextid(to.params.trackid).then(() => {
      next();
    });
  },
  mounted() {
    let curpage = 1;
    this.endnum = this.endnum * Number(curpage);
    this.pager = curpage;

    this.setCurrentModule("Testgroups");

    this.fetchData();
    this.fetchAnalyticsData()
  },
  methods: {
    ...mapActions("admin", ["setQuery", "fetchInstitutionsTable", "setinextid", "setCurrentModule", "fetchTestgroupsAnalytics", "deleteInstitution"]),

    async fetchData() {
      this.loading = true;
      try {
        await this.fetchInstitutionsTable();
        this.endnum = this.meta.perPage * Number(this.meta.page);
        this.loading = false;
      } catch (err) {
        console.log(err);
      }
    },
    async fetchAnalyticsData() {
      this.loading2 = true;
      try {
        const response = await this.fetchTestgroupsAnalytics();
        this.analyticsData = response?.data;
        this.loading2 = false;

        console.log(response);
      } catch (err) {
        console.log(err);
        this.loading2 = false;
      }
    },
    newPage(page) {
      // alert(page)
      this.pages = page;
      //   let newend = this.intervalnum * page;

      let search = this.searchQuery.length > 0 ? `&search=${this.searchQuery}` : "";
      this.setQuery(`page=${this.pages}&perPage=${this.intervalnum}${search}`);
      this.fetchData()
    },
    effectInterval(newinterval) {
      this.intervalnum = newinterval;
      this.pages = 1;
      this.newPage(this.pages);
    },
    clearField() {
      this.searchQuery = "";
      this.closeSearch();
    },

    async clearFilter(event) {
      if (event?.length == 0) {
        this.setQuery(`page=${this.pages}&perPage=${this.intervalnum}`);
        this.fetchInstitutionsTable();
      }
    },

    async searchFilter() {
      this.searching = true;
      //   let query = this.searchQuery;

      try {
        if (this.searchQuery.length == 0) {
          this.clearField();
          this.setQuery(`page=${this.pages}&perPage=${this.intervalnum}`);
          await this.fetchInstitutionsTable();
          this.searching = false;
        } else {
          this.setQuery(
            `page=${this.pages}&perPage=${this.intervalnum}&search=${this.searchQuery}`
          );
          await this.fetchInstitutionsTable();
          this.searching = false;
        }
      } catch (err) {
        console.log(err);
      }
    },
    closeSearch() {
      this.searching = false;
      this.searchQuery = "";
    },
    confirmDelete() {
      this.$bvModal.show("modal-delete-space");
    },
    deleteTestgroup() {
      return this.deleteInstitution(this.currentId).then(() => {
        this.fetchData();
        this.fetchAnalyticsData()
      });
    },
  },
  computed: {
    ...mapState({
      name: (state) => state.loginmaster.details.fullname,
      institutionsarr: (state) => state.admin.listinstitutions.data,
      meta: state => state.admin.listinstitutions.meta,
      details: state => state.loginmaster.details
    }),
    headers() {
      return [
        "sn",
        "name",
        "short_name",
        this.details.clearance_organization == "Quicktest"
          ? ""
          : "",
        "available",
        "structure",
        "uploadedby",
        "date_uploaded",
        "action"
      ];
    },
    usedatas() {
      return this?.institutionsarr
    },
    endss() {
      let end = this.meta?.total;
      return end;
    },
  },
};
</script>

<style scoped>

.nested-form-group {
  margin-top:20px;
  display: flex;
  flex-wrap: no-wrap;
  flex-direction: row-reverse;
  justify-content: space-between;
}

.list-heads {
    background-color: #00984A;
    color: white;
    border-radius: 5px 5px;
    font-weight: bold;
    display: flex;
    flex-flow: row wrap;
}
.head-p{
    width: 14%;
    padding: 2px;
}

.board-wrapper {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  width: 100%;
}
.board-items {
  width: 30%;
  margin: 3px;
}

@media screen and (max-width: 999px) {
     .head-p{
        font-size: 0.6rem
    }
    .page-buttons{
        width: 25px;
        height: 25px;
        padding: 0px 0px 0px 5px ;
    }

    .board-items {
      width: 100%;
      margin: 3px;
    }
}
</style>
